import React, { Component } from 'react'; //different
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import SiteConfig from './SiteConfig';
import { spaNav } from './spaNav';
import { t } from './i18n';
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }


    render() {
        const lang = localStorage.getItem('lang') || 'th';
        const BG = '/build/web/igame-index-lobby-ae-sexy/img/special-menu-entry-item-bg.png?v=1';
        const specialMenuMap = {
            wheel: { cls: '-menu-birth-date', delay: 200 },
            social_share: { cls: '-menu-social-share', delay: 50 },
            bind_social: { cls: '-menu-bind-social', delay: 100 },
            affiliate: { cls: '-menu-invitation', delay: 150 },
            birthday: { cls: '-menu-birth-date', delay: 200 },
            movie: { cls: '-menu-movie', delay: 300 },
        };

        return (
            <>
                <div className="container">
                    <div className="x-special-menu-entry -main-container">
                        <ul className="nav -nav">
                            {SiteConfig.SpecialMenuItems.filter(i => i.enabled !== false).map((item, idx) => {
                                const m = specialMenuMap[item.labelKey] || { cls: '', delay: 0 };
                                const label = (item.labels && (item.labels[lang] || item.labels.th)) || '';
                                const isModal = typeof item.url === 'string' && item.url.startsWith('#');
                                const isExternal = typeof item.url === 'string' && item.url.startsWith('http');
                                const target = isExternal ? '_blank' : '_self';
                                const rel = isExternal ? 'noopener nofollow' : undefined;
                                const inner = (
                                    <>
                                        <img
                                            alt={label}
                                            title={label}
                                            className="-bg"
                                            src={BG}
                                        />
                                        <img
                                            alt={label}
                                            title={label}
                                            className="-text-img img-fluid"
                                            src={item.img}
                                        />
                                    </>
                                );
                                return (
                                    <li className="nav-item" key={idx}>
                                        {isModal ? (
                                            <a
                                                href={item.url}
                                                className={`nav-link ${m.cls} animated fadeInUp`}
                                                data-toggle="modal"
                                                data-target={item.url}
                                                data-dismiss="modal"
                                                data-animatable="fadeInUp"
                                                data-delay={m.delay}
                                                title={label}
                                            >
                                                {inner}
                                            </a>
                                        ) : (
                                            <a
                                                href={item.url}
                                                className={`nav-link ${m.cls} animated fadeInUp`}
                                                target={target}
                                                rel={rel}
                                                data-animatable="fadeInUp"
                                                data-delay={m.delay}
                                                title={label}
                                                onClick={(e) => spaNav(e, item.url)}
                                            >
                                                {inner}
                                            </a>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}
export default App;
